import React, { Component } from "react";
import { Link } from "react-router-dom";

import ExpandParagraph from "../component/Expand-paraghraph";
import Modal from "react-awesome-modal";
import { formSubmit } from "./../assets/utils";

// import Modal from "../component/Modal/Modal";
// import configs from './../config'

class Main extends Component {
  state = {
    modalIsOpen: false,
    modalContent: {
      title: null,
      content: null
    }
  };
  formContent = (
    <form onSubmit={() => this.submit}>
      <input type="text" />
      <input type="text" />
      <input type="text" />
      <button
        type="submit"
        className="IP-submit shadow-2"
        id="IP-submit"
        onClick={this.onSubmit}
      >
        Հաստատել
      </button>
    </form>
  );
  submit = event => {
    formSubmit(event, {});
  };
  componentDidMount() {
    const div = document.createElement("div");

    setTimeout(function() {
      const comercialBox = document.querySelector("#sc_header");
      const comercialBox2 = document.querySelector("#sc_footer");
      if (comercialBox) {
        comercialBox.parentNode.removeChild(comercialBox);
      }
      if (comercialBox2) {
        comercialBox2.parentNode.removeChild(comercialBox2);
      }
    });
    div.setAttribute("class", "ilustration");
    div.setAttribute("id", "ilustration");
    const scWrap = document.querySelector(".sc-wrap");
    if (scWrap) scWrap.parentNode.insertBefore(div, scWrap);
    window.scrollTo(0, 0);
    console.log("scrol to top");
  }
  componentWillUnmount() {
    const ilustrtaion = document.querySelector("#ilustration");
    ilustrtaion && ilustrtaion.parentNode.removeChild(ilustrtaion);
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }
  openModal(index) {
    const modalContents = [
      {
        title: "title one",
        content: <p> content one </p>
      },
      {
        title: "title two",
        content: <p> content two </p>
      },
      {
        title: "title thre",
        content: <p> content thr </p>
      },
      {
        title: "title thre",
        content: this.formContent
      }
    ];
    this.setState({
      modalIsOpen: true,
      modalContent: modalContents[index]
    });
  }
  render() {
    return (
      <div className="main">
        <div className="h-50" />
        <div className="intro">
          <h1 className="header text-center">Օնլայն ուսուցիչ</h1>
          <div className="h-50" />
          <div className="h-50" />
        </div>
        <div className="advantage">
          <div className="row mw">
            <div className="col-xs-4 col_1">
              <div className="im_size">
                <img
                  className="IP-icons"
                  alt="գումարի խնայում"
                  src="https://imdproc-uploads-prod.s3.amazonaws.com/upload/contentpages/icon_1.png"
                />
              </div>

              <h3 className="text-center advantage">Գումարի խնայում</h3>
            </div>
            <div className="col-xs-4 col_1">
              <div className="im_size">
                <img
                  className="IP-icons"
                  alt="ժամանակի խնայում"
                  src="https://imdproc-uploads-prod.s3.amazonaws.com/upload/contentpages/icon_2.png"
                />
              </div>

              <h3 className="text-center advantage">Ժամանակի խնայում</h3>
            </div>
            <div className="col-xs-4 col_2">
              <div className="im_size">
                <img
                  className="IP-icons"
                  alt="առաջադիմության աճ"
                  src="https://imdproc-uploads-prod.s3.amazonaws.com/upload/contentpages/icon_3.png"
                />
              </div>

              <h3 className="text-center advantage w-b">Պրոգրես</h3>
            </div>
          </div>



          <div className="h-50" />
          <div className="info-wraper">
            <h2 className="header text-center">
              Աշխարհում մեծ փորձ ու հաջողություն վայելած օնլայն պարապմունքները
              Հայաստանում
            </h2>
            <ExpandParagraph>
              Սիրելի՛ ծնողներ, «ԻմԴպրոց»-ի առաջնային նպատականերից է ստեղծել
              հրապուրիչ ուսումնական միջավայր, որը երեխայի մոտ կարթնացնի
              սովորելու մոտիվացիան և կապահովի առաջադիմության աճ։ «ԻմԴպրոց»-ը
              յուրաքանչյուր աշակերտի հնարավորություն է տալիս սովորել «սովորել» և
              ինքնուրույն հասնել ուսումնական հաջողությունների անգամ այն
              առարկաներում, որոնք հեշտությամբ նրանց չեն տրվում։ Գործում է մի
              հայտնի իրողություն՝ երեխան չհասկացավ-չկարողացավ-չսիրեց։ Մենք թույլ
              ենք տալիս, որ երեխան ձերբազատվի իր վախերից, որոնք կապված են այս
              կամ այն առարկայում չհաջողելու հետ։ Իսկ երեխաների ամբողջական
              պոտենցիալը բացահայտելու ճանապարհին հմուտ մանկավարժի աջակցությունն
              ապահովելը ավելի քան ցանկալի է։ /// Հաշվի առնելով ծնողների բազմաթիվ
              խնդրանքները՝ ձեզ ենք ներկայացնում մի ծրագիր, որի շրջանակներում
              յուրաքանչյուր աշակերտ հնարավորություն է ստանալու իր գիտելիքները
              կառուցելու ճանապարհին ուղղորդվել այնպիսի մասնագետների կողմից,
              ովքեր լավագույններից են իրենց գործում։ Ծրագիրը նախատեսված է և՛
              տարրական դասարանների աշակերտների, և՛ առարկայից խորքային գիտելիքներ
              ձեռք բերել ցանկացող, և՛ քննություններին ու ցանկացած բնույթի
              աշխատանքներին նախապատրաստվող աշակերտների համար։
            </ExpandParagraph>
          </div>
          <div className="h-50" />
        </div>

        <div className="video" />

        {/*<section>*/}
          {/*<div className="row mw">*/}
            {/*<div className="col-xs-4 col_1">*/}
              {/*<div className="modal-buttons">*/}
                {/*<input*/}
                  {/*type="button"*/}
                  {/*value="Open modal 1"*/}
                  {/*onClick={() => this.openModal(0)}*/}
                {/*/>*/}
              {/*</div>*/}
              {/*<h3 className="text-center advantage">Գումարի խնայում</h3>*/}
            {/*</div>*/}

            {/*<div className="col-xs-4 col_1">*/}
              {/*<div className="modal-buttons">*/}
                {/*<input*/}
                  {/*type="button"*/}
                  {/*value="Open modal 2"*/}
                  {/*onClick={() => this.openModal(1)}*/}
                {/*/>*/}
              {/*</div>*/}
              {/*<h3 className="text-center advantage">Գումարի խնայում</h3>*/}
            {/*</div>*/}

            {/*<div className="col-xs-4 col_1">*/}
              {/*<div className="modal-buttons">*/}
                {/*<input*/}
                  {/*type="button"*/}
                  {/*value="Open modal 3"*/}
                  {/*onClick={() => this.openModal(3)}*/}
                {/*/>*/}
              {/*</div>*/}
              {/*<h3 className="text-center advantage">Գումարի խնայում</h3>*/}
            {/*</div>*/}
          {/*</div>*/}

          {/*<Modal*/}
            {/*visible={this.state.modalIsOpen}*/}
            {/*width="400"*/}
            {/*height="300"*/}
            {/*effect="fadeInUp"*/}
            {/*onClickAway={() => this.closeModal()}*/}
          {/*>*/}
            {/*<div>*/}
              {/*<h1>{this.state.modalContent.title}</h1>*/}
              {/*{this.state.modalContent.content}*/}
              {/*<a href="javascript:void(0);" onClick={() => this.closeModal()}>*/}
                {/*Close*/}
              {/*</a>*/}
            {/*</div>*/}
          {/*</Modal>*/}
        {/*</section>*/}

        <div className="type">
          <div className="row">
              <div className="col-sm-4">
                  <Link className="subj-link" to={'/elementary'}>
                      <div className="subject-card">
                          <div className="subj-img">
                              <img src="https://imdproc-uploads-prod.s3.amazonaws.com/upload/custom-pages/im-ognakan/way/elem.cut.jpg" alt=""/>
                              <div className="classes"><p className="text-center">1-4</p></div>
                          </div>
                          <div className="subj-content">
                              <h3>Տարրական</h3>
                              <p>Դասապատրաստում և անհրաժեշտ գիտելիքների ձեռքբերում</p>
                          </div>
                      </div>
                  </Link>
              </div>
            <div className="col-sm-4">
              <Link className="subj-link" to={"/deeplearning"}>
                <div className="subject-card">
                  <div className="subj-img">
                    <img
                      src="https://imdproc-uploads-prod.s3.amazonaws.com/upload/custom-pages/im-ognakan/way/deep.cut.jpg"
                      alt=""
                    />
                    {/*<div className="way-name">Խորքային</div>*/}
                    <div className="classes">
                      <p className="text-center">5-10</p>
                    </div>
                  </div>
                  <div className="subj-content">
                    <h3>Խորացված </h3>
                    <p>Խորացված ուսուցում ընտրված առարկայից</p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-sm-4">
              <Link className="subj-link" to={"/final"}>
                <div className="subject-card">
                  <div className="subj-img">
                    <img
                      src="https://imdproc-uploads-prod.s3.amazonaws.com/upload/custom-pages/im-ognakan/way/final.cut.jpg"
                      alt=""
                    />
                    <div className="classes">
                      <p className="text-center">4, 9, 10-12</p>
                    </div>
                  </div>
                  <div className="subj-content">
                    <h3>Քննական</h3>
                    <p>
                      Ավարտական քննություններին և կիսամյակային աշխատանքներին
                      նախապատրաստում
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Main;
